import type { ReactNode } from 'react';
import SolarIcon from 'components/icons/SolarIcon';

interface AiInfoBlockProps {
    title?: string;
    children: ReactNode;
}

const AiInfoBlock = ({ title, children }: AiInfoBlockProps) => (
    <div className="ai-info-block">
        <div className="ai-info-block-header">
            <span className="ai-info-block-icon" aria-hidden="true">
                <SolarIcon name="stars" />
            </span>
            {title && <span className="ai-info-block-title">{title}</span>}
        </div>
        <div className="ai-info-block-body">{children}</div>
    </div>
);

export default AiInfoBlock;
